import { DatabaseTable } from "../../../shared/components/ui/DatabaseTable";
import { useDashboard } from "../context/useDashboard";
import type { GridColDef } from "@mui/x-data-grid";
import { Chip } from "@mui/material";

export const ReservationTable = () => {
    const { dashboardSummaryToday, isLoadingDashboardSummaryToday } = useDashboard();

    const columns: GridColDef[] = [
        { field: 'title', headerName: 'Título', flex: 1 },
        { field: 'room', headerName: 'Sala', flex: 1 },
        { field: 'userName', headerName: 'Responsável', flex: 1 },
        {
            field: 'startDate',
            headerName: 'Data de Início',
            flex: 1,
            valueFormatter: (params) => {
                return new Date(params.value).toLocaleString('pt-BR');
            }
        },
        {
            field: 'endDate',
            headerName: 'Data de Término',
            flex: 1,
            valueFormatter: (params) => {
                return new Date(params.value).toLocaleString('pt-BR');
            }
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 1,
            renderCell: (params) => (
                <Chip
                    label={params.value}
                    color={params.value === 'CANCELLED' ? 'error' : 'success'}
                    size="small"
                    variant="outlined"
                />
            )
        }
    ];

    return (
        <DatabaseTable 
            columns={columns} 
            rows={dashboardSummaryToday?.reservations || []} 
            hideDelete 
            hideEdit 
            hideView 
            loading={isLoadingDashboardSummaryToday} 
            title="Reservas Recentes" 
        />
    );
}; 